var _path, _path2, _path3, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIranFlag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 630,
    height: 360,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#da0000",
    d: "M0 0h630v360H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h630v240H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#239f40",
    d: "M0 0h630v120H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.4 100.4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M0 1h26M1 10V5h8v4h8V5h-5M4 9h2m20 0h-5V5h8m0-5v9h8V0m-4 0v9",
    transform: "scale(1.4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 7h9m1 0h9",
    transform: "scale(2.8)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    y: 120
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    y: 145.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    x: 56
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    x: 112
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    x: 168
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    x: 168
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e",
    x: 392
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#da0000",
    transform: "matrix(45 0 0 45 315 180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-.548.836A.912.912 0 00.329-.722 1 1 0 01-.548.836"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.618.661A.764.764 0 00.422-.74 1 1 0 01.618.661M0 1l-.05-1L0-.787a.31.31 0 00.118.099V-.1l-.04.993zM-.02-.85L0-.831a.144.144 0 00.252-.137A.136.136 0 010-.925"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f",
    transform: "scale(-1 1)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIranFlag);
export default __webpack_public_path__ + "static/media/iran-flag.9f951dd00701c86c98f7d9d6819b0e11.svg";
export { ForwardRef as ReactComponent };